<template>
  <div class="d-flex align-center my-2">
    <v-icon
      color="blue darken-2"
      class="mr-2"
    >
      mdi-microsoft-sharepoint
    </v-icon>

    <v-text-field
      v-model="url"
      outlined
      dense
      hide-details="auto"
      label="Paste a SharePoint / OneDrive link"
      placeholder="https://yourorg.sharepoint.com/..."
      :error-messages="error ? [error] : []"
      :disabled="loading"
      class="flex-grow-1"
    >
      <template #append>
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="20"
          width="2"
          color="primary"
        />
      </template>
    </v-text-field>

    <v-btn
      icon
      color="primary"
      class="ml-1"
      :disabled="!url || loading"
      title="Add OneDrive file"
      @click="_ => submitFile()"
    >
      <v-icon>mdi-check</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { DOCKET_ENTRY_NAMESPACE } from '@/store/docket-entry'
import { parseErrorResponseMessage } from '@/utilities'

export default {
  name: 'OneDriveFileInput',

  data () {
    return {
      error: null,
      loading: false,
      pendingUrls: [],
      url: '',
    }
  },

  methods: {
    extractName (url) {
      try {
        const pathname = decodeURIComponent(new URL(url).pathname)
        const segments = pathname.split('/').filter(Boolean)
        const fileSeg = segments.reverse().find(s => s.includes('.'))
        return fileSeg || 'SharePoint File'
      } catch {
        return 'SharePoint File'
      }
    },

    getPendingUrls () {
      return [...this.pendingUrls]
    },

    removePendingUrl (url) {
      const index = this.pendingUrls.indexOf(url)
      if (index !== -1) this.pendingUrls.splice(index, 1)
    },

    resetPending () {
      this.pendingUrls = []
    },

    submitFile () {
      this.error = null
      this.loading = true
      const submittedUrl = this.url
      const pendingId = `pending-${Date.now()}`

      this.$emit('file-pending', {
        fetchStatus: 'loading',
        file_name: this.extractName(submittedUrl),
        id: pendingId,
        sharepoint_url: submittedUrl,
      })
      this.url = ''

      this.validateSharepointFile(submittedUrl).
        then(data => {
          this.pendingUrls.push(submittedUrl)
          this.$emit('file-validated', {
            fetchStatus: 'fetched',
            file_name: data.file_name,
            file_size: data.file_size,
            id: pendingId,
            mime_type: data.mime_type,
            warning: data.warning,
          })
        }).
        catch(err => {
          this.$emit('file-validated', {
            error: parseErrorResponseMessage(err) || 'Validation failed',
            fetchStatus: 'error',
            id: pendingId,
          })
        }).
        finally(_ => {
          this.loading = false
        })
    },

    submitPendingFiles (docketEntryId) {
      const requests = [...this.pendingUrls].map(pendingUrl => {
        return this.createSharepointFile({ docketEntryId, sharepointUrl: pendingUrl }).
          then(data => {
            this.$emit('file-added', data)
            this.pendingUrls = this.pendingUrls.filter(url => url !== pendingUrl)
            return data
          })
      })

      return Promise.all(requests)
    },

    ...mapActions(DOCKET_ENTRY_NAMESPACE, [
      'createSharepointFile',
      'validateSharepointFile',
    ]),
  },
}
</script>
